import { render, staticRenderFns } from "./validar-email.vue?vue&type=template&id=f5bea05e&"
import script from "./validar-email.vue?vue&type=script&lang=js&"
export * from "./validar-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5bea05e')) {
      api.createRecord('f5bea05e', component.options)
    } else {
      api.reload('f5bea05e', component.options)
    }
    module.hot.accept("./validar-email.vue?vue&type=template&id=f5bea05e&", function () {
      api.rerender('f5bea05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/validar-email.vue"
export default component.exports